import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './modules/Login/AuthContext';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './config/authConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

// ── Limpieza automática de localStorage al detectar nueva versión ──────────
// Cambia APP_VERSION cada vez que despliegues cambios importantes.
// Esto limpia automáticamente los datos viejos de todos los usuarios.
const APP_VERSION = '1.0.1';
const STORED_VERSION_KEY = 'app_version';
try {
  const storedVersion = localStorage.getItem(STORED_VERSION_KEY);
  if (storedVersion !== APP_VERSION) {
    // Guardar keys de MSAL antes de limpiar (para no cerrar sesión)
    const msalKeys = Object.keys(localStorage).filter(k =>
      k.startsWith('msal.') || k.startsWith('admeseasa.') || k.startsWith('eseasa_device_token')
    );
    const msalData = msalKeys.map(k => [k, localStorage.getItem(k)]);
    localStorage.clear();
    // Restaurar datos de MSAL
    msalData.forEach(([k, v]) => localStorage.setItem(k, v));
    localStorage.setItem(STORED_VERSION_KEY, APP_VERSION);
    console.log(`[App] Nueva versión (${APP_VERSION}): caché local limpiado.`);
  }
} catch (e) {
  // Si falla, no bloquear la app
}
// ─────────────────────────────────────────────────────────────────────────────


// Inicialización oficial de MSAL v5 antes de montar el árbol de React
msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then((response) => {
  if (response && response.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const currentAccounts = msalInstance.getAllAccounts();
    if (currentAccounts.length > 0) {
      msalInstance.setActiveAccount(currentAccounts[0]);
    }
  }

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MsalProvider>
    </React.StrictMode>
  );
}).catch((error) => {
  console.error("Error inicializando MSAL:", error);
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MsalProvider>
    </React.StrictMode>
  );
});

reportWebVitals();
